import { SCHOOL_URL, SPORTS_URL, MASTER_SPORTS_URL } from "../helpers/routes"
import { handleResponse, getParams, getMultipartParams, surfaceServerErrors } from "../helpers/validate"
import notice from "../../utils/notice"

export const  defaultSport = {
  active: true,
  name: "",
  description: "",
  color: "",
  icon: ""
}

export const defaultMasterSport = {
  active: true,
  name: "",
  description: "",
  color: "",
  icon: "",
  archived_at: null,
}

export const getSports = (setterFunction, slug, page = 1, query = "") => {
  return fetch(`${SCHOOL_URL}/${slug}/sports?page=${page}&search_query=${query}`, getMultipartParams('GET'))
  .then((res) => handleResponse(res))
  .then((json) => setterFunction(json))
  .catch(e => {
    notice("Error on loading the sports")
    console.error(e.errors)
    throw e
  })
}

export const getSport = (setterFunction, id) => {
  return fetch(`${SPORTS_URL}/show?id=${id}`, getMultipartParams('GET'))
  .then((res) => handleResponse(res))
  .then((json) => setterFunction(json))
  .catch(e => {
    notice("Error fetching the sport")
    console.error(e.errors)
    throw e
  })
}

export const searchSport = (setterFunction, slug, query) => {
  if (slug) {
    return fetch(`${SCHOOL_URL}/${slug}/sports/suggestions?q=${query}`, getMultipartParams('GET'))
    .then(res => handleResponse(res))
    .then(json => setterFunction(json))
    .catch(e => {
      notice("Error on loading sports")
      console.error(e.errors)
    })
  }
}

export const saveSport = (setterFunction, slug, data) => {
  const jsonData = JSON.stringify(data)

  return fetch(`${SCHOOL_URL}/${slug}/sports`, getParams('POST', jsonData))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Sport created", "success")
    setterFunction({sport: json})
  })
  .catch(e => {
    notice("Error saving the sport")
    console.error(e.errors)
    throw e
  })
}

export const updateSport = (setterFunction, slug, data, id) => {
  const jsonData = JSON.stringify(data)

  return fetch(`${SCHOOL_URL}/${slug}/sports/update?id=${id}`, getParams('PUT', jsonData))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Sport updated", "success")
    console.log(json)
    return setterFunction({sport: json})
  })
  .catch(e => {
    notice("Error saving the sport")
    console.error(e.errors)
    throw e
  })
}

// Master Sport list (Zone-wide canonical list, not school-scoped).
// Used by Zone Super Admin to curate the standardized sport names that
// all schools draw from. TZ-784.

export const getMasterSports = (setterFunction, page = 1, query = "") => {
  return fetch(`${MASTER_SPORTS_URL}?page=${page}&search_query=${query}`, getMultipartParams('GET'))
  .then(res => handleResponse(res))
  .then(json => setterFunction(json))
  .catch(e => {
    notice("Error loading master sports list")
    console.error(e.errors)
    throw e
  })
}

// For picker/dropdown use cases (e.g. Team Reconciliation): returns
// every active master sport in one shot, no pagination. The admin
// list page (paginated, includes archived) still uses getMasterSports.
// `per_page=500` exceeds any realistic master list size — backend
// paginateable honors the param with no cap.
export const getAllActiveMasterSports = (setterFunction) => {
  return fetch(`${MASTER_SPORTS_URL}?page=1&per_page=500`, getMultipartParams('GET'))
  .then(res => handleResponse(res))
  .then(json => {
    const items = (json.items || []).filter(s => !s.archived_at)
    setterFunction({
      items,
      total: items.length,
      page: 1,
      pages: 1,
      per_page: items.length,
    })
  })
  .catch(e => {
    notice("Error loading master sports list")
    console.error(e.errors)
    throw e
  })
}

export const getMasterSport = (setterFunction, id) => {
  return fetch(`${MASTER_SPORTS_URL}/${id}`, getMultipartParams('GET'))
  .then(res => handleResponse(res))
  .then(json => setterFunction(json))
  .catch(e => {
    notice("Error fetching master sport")
    console.error(e.errors)
    throw e
  })
}

export const saveMasterSport = (setterFunction, data) => {
  const jsonData = JSON.stringify(data)

  return fetch(MASTER_SPORTS_URL, getParams('POST', jsonData))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Master sport created", "success")
    setterFunction({ sport: json })
  })
  .catch(e => {
    notice(surfaceServerErrors(e, "Error creating master sport"))
    console.error(e.errors)
    throw e
  })
}

export const updateMasterSport = (setterFunction, data, id) => {
  const jsonData = JSON.stringify(data)

  return fetch(`${MASTER_SPORTS_URL}/${id}`, getParams('PUT', jsonData))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Master sport updated", "success")
    setterFunction({ sport: json })
  })
  .catch(e => {
    notice(surfaceServerErrors(e, "Error updating master sport"))
    console.error(e.errors)
    throw e
  })
}

export const archiveMasterSport = (setterFunction, id) => {
  return fetch(`${MASTER_SPORTS_URL}/${id}/archive`, getParams('PUT'))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Master sport archived", "success")
    setterFunction({ sport: json })
  })
  .catch(e => {
    notice("Error archiving master sport")
    console.error(e.errors)
    throw e
  })
}

export const unarchiveMasterSport = (setterFunction, id) => {
  return fetch(`${MASTER_SPORTS_URL}/${id}/unarchive`, getParams('PUT'))
  .then(res => handleResponse(res))
  .then(json => {
    notice("Master sport restored", "success")
    setterFunction({ sport: json })
  })
  .catch(e => {
    notice("Error restoring master sport")
    console.error(e.errors)
    throw e
  })
}